import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { AuthState, AuthAction } from './AuthModel'

const initialState: AuthState = {
  fetchCount: 0,
  userId: undefined,
  isUserIdLoading: true,
}

function authReducer(state: AuthState = initialState, action: AuthAction): AuthState {
  const stateWithSession = {
    ...state,
  }

  switch (action.type) {
    case 'AUTH_FETCH_ADD':
      return { ...stateWithSession, fetchCount: state.fetchCount + 1 }
    case 'AUTH_FETCH_SUB':
      return { ...stateWithSession, fetchCount: state.fetchCount - 1 }
    case 'SET_USER_ID':
      return { ...stateWithSession, userId: action.userId }
    case 'SET_IS_USER_ID_LOADING':
      return { ...stateWithSession, isUserIdLoading: action.isUserIdLoading }
    case 'RESET_USER_ID':
      return { ...stateWithSession, userId: undefined }
    default:
      return stateWithSession
  }
}

const persistConfig = {
  key: 'auth',
  storage: storage,
  whitelist: [],
}

export default persistReducer(persistConfig, authReducer)
